export const yandexTrackerIssueUrl = issueKey => {
    return `https://tracker.yandex.ru/${issueKey}`;
};

export const yandexTrackerQueueUrl = queue => {
    return `https://tracker.yandex.ru/${queue}`;
};

export const yandexTrackerProjectUrl = projectId => {
    return `https://tracker.yandex.ru/pages/projects/${projectId}`;
};